var map = {
	"./advances-B.svg": "b8f2",
	"./advances-Y.svg": "848c",
	"./amazon.svg": "f1d9",
	"./apple.svg": "f9d5",
	"./bandcamp.svg": "0717",
	"./brand_report.svg": "fd06",
	"./cd.svg": "f3d6",
	"./cid-B.svg": "d606",
	"./cid-Y.svg": "e24d",
	"./deezer.svg": "0936",
	"./discord.svg": "e3a3",
	"./distribution-B.svg": "11ed",
	"./distribution-Y.svg": "3646",
	"./facebook.svg": "8485",
	"./icon-check.svg": "dc7b",
	"./icon-close.svg": "3324",
	"./info.svg": "76ed",
	"./instagram.svg": "bd6c",
	"./label-white.svg": "691f",
	"./link.svg": "40a1",
	"./linkedin.svg": "9ed9",
	"./notes.svg": "8190",
	"./promotion-B.svg": "a9b6",
	"./promotion-Y.svg": "9e4d",
	"./shorts-red.svg": "a56f",
	"./soundcloud.svg": "8ba6",
	"./spotify.svg": "86ec",
	"./tiktok.svg": "68b6",
	"./twitter.svg": "acf9",
	"./vc.svg": "5b9b",
	"./youtube.svg": "11ef",
	"./yt-gray.svg": "d868",
	"./yt-red.svg": "f476"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";